var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4c11.046 0 20 8.954 20 20 0 9.983-7.314 18.257-16.875 19.757V29.781h4.66L32.672 24h-5.547v-3.752c0-.424.056-.846.186-1.236.293-.88.963-1.598 2.22-1.818q.388-.068.853-.069h2.522v-4.922s-2.288-.39-4.477-.39c-4.568 0-7.554 2.768-7.554 7.78V24h-5.078v5.781h5.078v13.976C11.314 42.257 4 33.983 4 24 4 12.954 12.954 4 24 4"
  })));
};
export default SvgFacebook;